import { Component, OnInit, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIEntityService } from '../../_services/entity/API-entity';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { formatDate } from '@angular/common';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { map } from 'rxjs/operators';


import { MatDialog, } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";
import { APIPaymentService } from '../../_services/payment-dues/payment-dues.service';
import { GstRegistrationService } from '../../_services/gst-registration/gst-registration.service';
import { Router } from '@angular/router';

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  selector: 'app-gstregistration-search',
  templateUrl: './gstregistration-search.component.html',
  styleUrls: ['./gstregistration-search.component.css']
})
export class GstregistrationSearchComponent {



  dataSource: MatTableDataSource<any>;
  onSelectdropdown: boolean = true;
  filterData: any;
  noRecord: any;
  URN: any;
  afterApply: boolean = false;
  Entity_ID: any;
  EntityLegalName: any;
  GstNumber: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Address: any;
  Pin: number;
  State: any;
  Location: any;
  filterForm: FormGroup;
  queryData: any;
  download: any;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('tSort') tSort: MatSort;


  dataSubject = new BehaviorSubject<any[]>([]);

  displayedColumns: string[] = ['URN', 'Entity_ID', 'GstNumber', 'EntityLegalName',
    'Address', 'Location',  'Pin', 'State', 'RegDate', 'Status', 'GST_Certification'];



  form1: any = {};
  
   constructor(
    private es: APIEntityService,
    private $modal: $ModalManagerService,
    public dialog: MatDialog,
    private gs: GstRegistrationService,
    private db: $DBManagerService,
    private router: Router
  ) { }
  
  
   ngOnInit() {
  
  //  this.maxDate.setDate(new Date().getDate());
 
     
	this.initialStep();	  
	//this.getGstregistrationSearchDetails(this.queryData)
	 
  }
  
  initialStep(){
	  
	  this.Entity_ID = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
	  this.queryData = {

        param: "",
        filterType: "",
        Entity_ID: this.Entity_ID
      }
      this.getGstregistrationSearchDetails(this.queryData)
  }

  onChangeDataSource(value) {
    console.log("values" + value);
    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator.toArray()[0];
    this.dataSource.sort = this.tSort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }
  
  searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }
  downloadgstcert(URN,filename) {
	 // filename=this.GSTDocName
	// URN: filename
		this.gs.downloadGSTCert(URN)
			.subscribe(r => {
				console.log(r)
				//if (r && r.length > 0) {
				importedSaveAs(r, filename)

				//}

			});
	}
  
  onSubmitFilter(filterForm, form) {
    let data = this.setupFilterCrit(filterForm, form)
   // this.getGstRegistrationWorklist(data);
  }
  
  setupFilterCrit(filterForm, form) {
    if (!form.valid) {
      return true;
    }
	
	let searchVal;
    if (filterForm.search) {
      searchVal = filterForm.search.trim();
    }
    else
    {
      searchVal=""
    }
    let searchBy;
    if (filterForm.searchBy) {
      searchBy = filterForm.searchBy.trim();
    }
    else
    {
      searchBy=""
    }
	
	 this.queryData = {

        param: searchVal,
        filterType: searchBy,
        Entity_ID: this.Entity_ID
      }
     
    	
	if((filterForm.searchBy==null || filterForm.searchBy=='undefined') && (filterForm.search==null || filterForm.search== 'undefined') ){
        alert("Please select any option") 
    }
	
	else{
		
		   this.getGstregistrationSearchDetails(this.queryData);
		
		}
  }
  getGstregistrationSearchDetails(data){
	    this.gs.getGstregistrationSearchDetails(this.queryData)
      .subscribe(r => {
		  
		
		console.log("r.status",r.status)
		console.log("r.message",r.message)
		console.log("r.data",r.data)
		if(r.status == "success") {
		this.filterData = r.data;
	    this.afterApply = true;		
        this.onChangeDataSource(this.filterData);
        console.log("12345 :", this.filterData);
		}
		else if(r.status == "failure") {
				this.$modal.errorModal({
				title: 'Search GST Registration',
				msg: r.message
				})
				this.reset()
		}
		else{
			this.$modal.errorModal({
		
				title: 'Search GST Registration',
				msg: 'Error Searching the GST Contact Administration'
				
			})
			this.reset()
		}
      })
	  
  }
  
  onOptionsSelected(data) {

    if (data === "GST_Status") {
      this.onSelectdropdown = false;
    } else {
      this.onSelectdropdown = true;
    }
    this.form1.search = "";
  }

  reset() {
    
    console.log("first reset function");
	this.initialStep();
	this.onSelectdropdown = true;
    this.searchRequired = false;
    this.afterApply = false;
	

  }

 downloadGstRegistrationSearchcsvfile(filterForm, form) {
	  
	  console.log("his.form1.search",this.form1.search);
	  console.log("his.form1.searchby",this.form1.searchBy);
     var data = {
        
        param: this.form1.search,
        filterType: this.form1.searchBy,
        Entity_ID: this.Entity_ID
      }
	  

    var fileName;
    const currentdate = formatDate(new Date(), 'medium', 'en-US', '+0530');
    this.gs.exportGstSearchCSV(data).subscribe(r => {
      fileName = currentdate + this.Entity_ID + 'GST.csv';
      importedSaveAs(r, fileName)
      this.$modal.successModal({
        title: 'GST Registration Search',
        msg: 'File has been downloaded Successfully'

      });
    })

 }

  gotoAction(URN) {
    this.db.set(Constants.SESSSION_STORAGE, Constants.URNFORGST,URN);
	this.router.navigate(['gstregistration-details']);
  }


}
